import { Component, inject, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
   
  selector: 'siat-go-back',
  imports: [RouterModule, MatIconModule, TranslatePipe],
  templateUrl: './go-back.component.html',
})
export class GoBackComponent {
  @Input()
  link: string;

  router = inject(Router);

  onClickGoBackButton(): void {
    this.router.navigate([this.link]);
  }
}
